module.exports = __webpack_public_path__ + "img/b03.a0e6588c.png";